var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"custom-style","position":"top center","classes":"n-light","max":3,"ignoreDuplicates":true,"closeOnClick":true,"width":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }